import { Action } from '@anm/components/ActionsDropdown';
import { Item } from '@anm/components/ActionsDropdown/ActionItem';
import Tooltip from '@anm/components/Tooltip';
import TooltipWrapper from '@anm/components/Tooltip/Wrapper';
import { flexCenter } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

import DuplicateTooltipContent from '../DuplicateTooltipContent';

export type DuplicateUpgradeTooltipProps = {
  action: Action;
  handler?: () => void;
};

export const DuplicateActionItemWrapper = styled.div`
  width: 100%;
  padding-right: 12px;
  ${flexCenter};
  &:hover {
    background-color: rgba(32, 171, 210, 0.1);
  }
`;

const DuplicateUpgradeTooltipWrapper = styled.div`
  width: 100%;
  ${TooltipWrapper} {
    width: 100%;
  }
`;

const DuplicateUpgradeTooltip: FC<DuplicateUpgradeTooltipProps> = ({ action, handler }) => (
  <DuplicateUpgradeTooltipWrapper>
    <Tooltip direction="top-center" renderContent={() => <DuplicateTooltipContent />}>
      <DuplicateActionItemWrapper>
        <Item {...action} {...{ handler }} isCrown={true} disabled={true} />
      </DuplicateActionItemWrapper>
    </Tooltip>
  </DuplicateUpgradeTooltipWrapper>
);

export default DuplicateUpgradeTooltip;
